import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=e418c43c&scoped=true&"
import script from "./footer.vue?vue&type=script&lang=js&"
export * from "./footer.vue?vue&type=script&lang=js&"
import style0 from "./footer.vue?vue&type=style&index=0&id=e418c43c&prod&scoped=true&lang=css&"
import style1 from "./footer.vue?vue&type=style&index=1&id=e418c43c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e418c43c",
  null
  
)

export default component.exports